import React from "react";
import "./PGAModelBuilderInput.css";

export default function PGAModelBuilderInput(props) {
  return <input className="pga-model-builder-input" {...props} />;
}
